"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CHANNEL_ICONS = exports.DEFAULT_CHANNELS = void 0;
var whatsapp_svg_1 = __importDefault(require("./icons/whatsapp.svg"));
var android_svg_1 = __importDefault(require("./icons/android.svg"));
var instagram_svg_1 = __importDefault(require("./icons/instagram.svg"));
var messenger_svg_1 = __importDefault(require("./icons/messenger.svg"));
var websdk_svg_1 = __importDefault(require("./icons/websdk.svg"));
var email_svg_1 = __importDefault(require("./icons/email.svg"));
var iOS_svg_1 = __importDefault(require("./icons/iOS.svg"));
var IVR_svg_1 = __importDefault(require("./icons/IVR.svg"));
exports.DEFAULT_CHANNELS = {
    WEBSDK: 5,
    DEFAULT: 'default',
};
exports.CHANNEL_ICONS = {
    14: whatsapp_svg_1["default"],
    2: android_svg_1["default"],
    3: messenger_svg_1["default"],
    41: instagram_svg_1["default"],
    5: websdk_svg_1["default"],
    37: email_svg_1["default"],
    6: iOS_svg_1["default"],
    16: IVR_svg_1["default"],
};
